export function setCustomer (state, customer) {
  state.customer = customer
}
